
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="FuelEfficiencyClassSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#545456" fill-rule="evenodd" d="M12.374 7.547h-5a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1v-2a1 1 0 00-1-1zm-4.7 2.7v-1.4h4.4v1.4h-4.4z" clip-rule="evenodd"/><path fill="#545456" fill-rule="evenodd" d="M5.55 4h8.446a1.585 1.585 0 011.538 1.355c.018-.024.038-.048.059-.071l.566-.615a1.094 1.094 0 01.806-.362h.038a1.1 1.1 0 01.818.42l1.749 2.174c.18.227.28.509.279.8v5.68a4.013 4.013 0 01-.637 2.37c-.087.125-.186.24-.295.342a1.29 1.29 0 01.72.465c.344.574.455 1.257.311 1.91v.023a2 2 0 01-1.877 1.506L5.55 19.95A1.584 1.584 0 014 18.337V5.615A1.585 1.585 0 015.55 4zm10 6.218V6.964l1.255 1.559v1.928a2.21 2.21 0 00-1.148-.329c-.13 0-.113.01-.084.027.03.018.072.042-.023.07zm0 1.142v.922a.783.783 0 01.48.134c.209.274.305.616.27.958a2.318 2.318 0 00.573 1.838c.17.148.388.228.613.228l.001.002a1 1 0 00.291-.044c.206-.05.937-.343.942-2.018.005-1.365 0-4.863 0-5.42v-.252l-1.75-2.174-.565.616 1.541 1.915v5.312c0 .95-.282 1.118-.323 1.137h-.02l-.038.015a.27.27 0 01-.238-.05c-.077-.062-.255-.299-.252-1.099a2.139 2.139 0 00-.576-1.68 1.131 1.131 0 00-.949-.34zm-1.225 5.973V5.615a.335.335 0 00-.329-.343H5.55a.336.336 0 00-.33.343v12.722a.336.336 0 00.33.343l12.515.048a.792.792 0 00.685-.518c.063-.284.04-.58-.066-.85-.007-.01-.023-.03-.107-.031a95.822 95.822 0 00-1.414-.008c-.969 0-2.002.007-2.192.008l-.646.004z" clip-rule="evenodd"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'FuelEfficiencyClassSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
